'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const jsxRuntime = require('react/jsx-runtime');
const React = require('react');
const hooks_useOverflow = require('../../../hooks/useOverflow.cjs.js');

const root = "_root_1mssy_1";
const content = "_content_1mssy_8";
const toggle = "_toggle_1mssy_21";
const styles = {
	root: root,
	content: content,
	toggle: toggle
};

const AlertDescription = ({ children, maxLines = 3 }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [isOverflowing, setOverflowingNode] = hooks_useOverflow.useOverflow();
  const toggle = isOverflowing && jsxRuntime.jsx("button", { className: styles.toggle, onClick: () => setIsOpen(!isOpen), type: "button", "data-zds": true, children: isOpen ? "show less" : "show more" });
  return jsxRuntime.jsxs("div", { className: styles.root, "data-zds": true, children: [jsxRuntime.jsx("div", { className: styles.content, "data-zds": true, ref: setOverflowingNode, style: {
    "--line-clamp": isOpen ? "initial" : maxLines
  }, children: jsxRuntime.jsx("div", { "data-zds": true, children }) }), toggle] });
};

exports.AlertDescription = AlertDescription;
//# sourceMappingURL=AlertDescription.cjs.js.map
